import { REMOTE__images_file_data_upload_to_workspace } from '@/state/images/upload/REMOTE__images_file_data_upload_to_workspace';
import { store } from '@/state/store';
import { assert_array_instanceof, assert_equal, assert_type_array } from '@shared/asserts/utils_asserts';
import { DTO_REQUEST__images_upload } from '@shared/dto/+image/DTO_REQUEST__images_upload';
import { DTO__file_data } from '@shared/dto/+image/image_asset_base/DTO__file_data';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { UTILS__graph_data } from '../UTILS__graph_data';

export async function FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph_list(file_data_list: DTO__file_data[], field: FIELD__list_image_asset) {
  //need to get generation_current here, before first await because it could be changed
  let { generation_current } = store.getState().slice_generation;

  /*
   * PREPARE REQUEST
   */

  let request_image_upload = new DTO_REQUEST__images_upload();
  request_image_upload.category = field.category;

  request_image_upload.file_data_list = file_data_list;
  request_image_upload.workspace_id = generation_current.workspace_id;

  let action_result = await store.dispatch(REMOTE__images_file_data_upload_to_workspace(request_image_upload));

  if (action_result.payload instanceof DTO_RESPONSE__error) return;

  /*
   * HANDLE RESPONSE
   */
  let images_assets = action_result.payload;

  assert_type_array(images_assets);
  assert_equal(images_assets.length, file_data_list.length);

  assert_array_instanceof(images_assets, DTO__image_asset);

  let images_hashes_in_list = field.items.map(image_asset => image_asset.hash_sha256_content);

  //keep assets that not in list
  images_assets = images_assets.filter(image_asset => !images_hashes_in_list.includes(image_asset.hash_sha256_content));

  if (images_assets.is_empty()) return; //nothing to add

  let graph_new = generation_current.tool.graph.clone();
  let field_list_new = field.clone();

  for (let image_asset of images_assets) {
    let field_item = field_list_new.items.find_or_default(item => item.hash_sha256_content.is_empty_hash_sha256(), FIELD__image_asset.CREATE_STUB());

    if (field_item.is_stub()) {
      field_item = field_list_new.create_item_new();
    }

    field_item.image__asset_use(image_asset.clone());
  }

  graph_new.field__replace(field_list_new);

  await UTILS__graph_data.update(graph_new);
}
